import React, { useState } from 'react';
import './ApprovalModal.css';

/**
 * Approval Modal Component
 * Confirms approval of a content or submission
 */
function ApprovalModal({ item, roleColor, onSubmit, onClose, type = 'content' }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmit(reason);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header" style={{ borderBottomColor: roleColor }}>
          <h3>Konfirmasi Persetujuan</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="approval-info">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            <p>Anda akan menyetujui {type === 'content' ? 'konten' : 'pengajuan'} berikut:</p>
            <h4>{item?.title || item?.name}</h4>
          </div>

          <div className="form-group">
            <label htmlFor="reason">Komentar (Opsional):</label>
            <textarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Tambahkan komentar atau catatan..."
              rows="4"
            />
            <small>Komentar Anda akan disimpan dalam catatan persetujuan</small>
          </div>
        </div>

        <div className="modal-footer">
          <button 
            className="btn btn-secondary"
            onClick={onClose}
            disabled={submitting}
          >
            Batal
          </button>
          <button 
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={submitting}
            style={{ backgroundColor: roleColor }}
          >
            {submitting ? 'Memproses...' : 'Setujui'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ApprovalModal;
